interface CalendarDateItemProps {
  props: {
    dateLabel: string;
    selectStyle: string;
    reserveStyle: string;
    onClick: () => void;
  };
}

export const CalendarDateItem = ({
  props: { dateLabel, selectStyle, reserveStyle, onClick },
}: CalendarDateItemProps) => {
  return (
    <div className={selectStyle} onClick={onClick}>
      <div className={'date-item-label'}>
        <span>{dateLabel}</span>
      </div>
      <div className={reserveStyle}>
        <i className={'status-icon'} />
      </div>
    </div>
  );
};
